/*
  Title-first search with a fallback.

  1. When a shopper submits a search, it is first run against product titles only
     (each word becomes title:word), so a name like "Lena" returns just the Lena styles.
  2. If that title-only search finds no products, the results page immediately re-runs
     the same words as a normal Shopify search, so "homecoming", "hoco", "prom" or
     "short dresses" still return results.

  The original title-only script is saved as strict-title-search-backup-oct7.js.
*/
(() => {
  if (window.__cleoStrictTitleSearch) return;
  window.__cleoStrictTitleSearch = true;

  const cleanQuery = (value) =>
    value.replace(/\btitle:/gi, ' ').replace(/\s+/g, ' ').trim();

  const titleQuery = (value) =>
    cleanQuery(value)
      .split(' ')
      .filter(Boolean)
      .map((term) => `title:${term}`)
      .join(' ');

  // Step 2: fall back to the normal search when the title-only search found no products.
  // This file is loaded before the results are on the page, so the check waits until the
  // whole page has been read.
  const fallBackIfNoTitleMatches = () => {
    if (!window.location.pathname.includes('/search')) return;

    const url = new URL(window.location.href);
    const query = url.searchParams.get('q') || '';
    if (!/\btitle:/i.test(query)) return;

    // The products grid is only rendered when the search returned products.
    if (document.getElementById('ShopProductsGrid')) return;

    const plainQuery = cleanQuery(query);
    if (!plainQuery) return;

    url.searchParams.set('q', plainQuery);
    document.documentElement.style.visibility = 'hidden';
    window.location.replace(url.toString());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fallBackIfNoTitleMatches);
  } else {
    fallBackIfNoTitleMatches();
  }

  const cleanVisibleInputs = (root = document) => {
    root
      .querySelectorAll('[data-strict-title-search] input[name="q"]:not([data-strict-title-query])')
      .forEach((input) => {
        input.value = cleanQuery(input.value);
      });
  };

  cleanVisibleInputs();

  if (window.location.pathname.includes('/search')) {
    document.title = document.title.replace(/title:/gi, '');
  }

  // Step 1: submit the search as a title-only search.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('[data-strict-title-search]');
      if (!form) return;

      const input = form.querySelector('input[name="q"]:not([data-strict-title-query])');
      if (!input) return;

      const query = titleQuery(input.value);
      if (!query) return;

      let strictInput = form.querySelector('[data-strict-title-query]');
      if (!strictInput) {
        strictInput = document.createElement('input');
        strictInput.type = 'hidden';
        strictInput.name = 'q';
        strictInput.dataset.strictTitleQuery = '';
        form.append(strictInput);
      }

      strictInput.value = query;
      input.removeAttribute('name');

      window.setTimeout(() => {
        input.name = 'q';
        strictInput.remove();
        cleanVisibleInputs(form);
      }, 1000);
    },
    true
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const input = event.target.closest(
        '[data-strict-title-search] input:not([data-strict-title-query])'
      );
      if (!input) return;

      input.value = cleanQuery(input.value);
      window.setTimeout(() => {
        input.value = cleanQuery(input.value);
      }, 0);
    },
    true
  );

  document.addEventListener(
    'click',
    () => {
      window.setTimeout(() => cleanVisibleInputs(), 0);
      window.setTimeout(() => cleanVisibleInputs(), 200);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    cleanVisibleInputs(event.target);
  });
})();
